import React, { forwardRef, useMemo } from 'react'
// import { DragIndicator } from '@styled-icons/material/DragIndicator'
import Tippy from '@tippyjs/react'
import {
    createNodesWithHOC,
    Draggable,
    ELEMENT_BLOCKQUOTE,
    ELEMENT_CODE_BLOCK,
    ELEMENT_H1,
    ELEMENT_H2,
    ELEMENT_H3,
    ELEMENT_H4,
    ELEMENT_H5,
    ELEMENT_H6,
    ELEMENT_IMAGE,
    ELEMENT_OL,
    ELEMENT_PARAGRAPH,
    ELEMENT_TABLE,
    ELEMENT_TODO_LI,
    ELEMENT_UL,
    grabberTooltipProps,
    PlateRenderElementProps,
    WithDraggableOptions,
    // withDraggables,
} from '@udecode/plate'
import { css } from 'styled-components'
import { useReadOnly, ReactEditor } from 'slate-react'
import { ELEMENT_VIDEO } from '../../../Plate'
// import tw from "twin.macro";

const withDraggable = (
    Component: any,
    {
        styles,
        level,
        filter,
        allowReadOnly = false,
        onRenderDragHandle,
    }: WithDraggableOptions = {}
) => {
    return forwardRef((props: PlateRenderElementProps, ref) => {
        const { attributes, element, editor } = props
        const readOnly = useReadOnly()
        const path = useMemo(
            () => ReactEditor.findPath(editor, element),
            [editor, element]
        )

        const filteredOut = useMemo(
            () =>
                (Number.isInteger(level) && level !== path.length - 1) ||
                (filter && filter(editor, path)),
            [path, editor]
        )

        if (filteredOut || (!allowReadOnly && readOnly)) {
            return <Component {...props} />
        }

        return (
            <Draggable
                editor={editor}
                attributes={attributes}
                element={element}
                componentRef={ref}
                styles={styles}
                onRenderDragHandle={onRenderDragHandle}
            >
                <Component {...props} />
            </Draggable>
        )
    })
}

const withDraggables = createNodesWithHOC(withDraggable)

export const withStyledDraggables = (components: any) => {
    return withDraggables(components, [
        {
            keys: [ELEMENT_PARAGRAPH, ELEMENT_UL, ELEMENT_OL],
            level: 0,
        },
        {
            keys: [
                ELEMENT_PARAGRAPH,
                ELEMENT_BLOCKQUOTE,
                ELEMENT_TODO_LI,
                ELEMENT_H1,
                ELEMENT_H2,
                ELEMENT_H3,
                ELEMENT_H4,
                ELEMENT_H5,
                ELEMENT_H6,
                ELEMENT_IMAGE,
                ELEMENT_OL,
                ELEMENT_UL,
                ELEMENT_TABLE,
                ELEMENT_VIDEO,
                ELEMENT_CODE_BLOCK,
            ],
            onRenderDragHandle: ({ ...props }) => {
                return (
                    <Tippy
                        {...grabberTooltipProps}
                        content={
                            <div
                                style={{
                                    fontSize: 12,
                                    backgroundColor: '#666',
                                    opacity: 0.8,
                                    color: 'white',
                                    padding: '2px 8px 0px 8px',
                                    borderRadius: '3px',
                                }}
                            >
                                <div>Færa</div>
                            </div>
                        }
                        offset={[0, -40]}
                    >
                        <button
                            type="button"
                            {...props}
                            style={{ height: '20px', width: '30px' }}
                        >
                            <svg
                                width="12"
                                height="5"
                                viewBox="0 0 12 5"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M0.75 3.16667H11.25V4.33333H0.75V3.16667ZM0.75 0.25H11.25V1.41667H0.75V0.25Z"
                                    fill="#858585"
                                />
                            </svg>
                        </button>
                    </Tippy>
                )
            },
        },
        {
            key: ELEMENT_H1,
            styles: {
                gutterLeft: css`
                    padding: 2em 0 4px;
                    //     font-size: 1.875em;
                `,
            },
        },
        {
            key: ELEMENT_VIDEO,
            contentEditable: false,
            styles: {
                gutterLeft: css`
                    user-select: none;
                    //     font-size: 1.875em;
                `,
            },
        },
        {
            key: ELEMENT_H2,
            styles: {
                gutterLeft: css`
                    padding: 1.4em 0 1px;
                    //     font-size: 1.5em;
                `,
            },
        },
        {
            key: ELEMENT_H3,
            styles: {
                gutterLeft: css`
                    padding: 1em 0 1px;
                    /* font-size: 1.25em; */
                `,
            },
        },
        {
            keys: [ELEMENT_H4, ELEMENT_H5, ELEMENT_H6],
            styles: {
                gutterLeft: css`
                    padding: 0.75em 0 0;
                    font-size: 1.1em;
                `,
            },
        },
        {
            keys: [ELEMENT_PARAGRAPH, ELEMENT_UL, ELEMENT_OL],
            styles: {
                // gutterLeft: tw`pt-1`,
            },
        },
        {
            key: ELEMENT_BLOCKQUOTE,
            styles: {
                // gutterLeft: tw`paddingTop[18px]`,
            },
        },
        {
            key: ELEMENT_CODE_BLOCK,
            styles: {
                // gutterLeft: tw`pt-3`,
            },
        },
    ])
}
